import { useState } from 'react'
import type { TextInputProps } from 'react-native'
import { Eye, EyeOff, Lock } from 'lucide-react-native'
import { TextField } from './TextField'

interface PasswordFieldProps extends Omit<TextInputProps, 'onPress'> {
  label: string
  showPasswordAccessibilityLabel: string
  hidePasswordAccessibilityLabel: string
  error?: string
  helperText?: string
}

export function PasswordField({
  showPasswordAccessibilityLabel,
  hidePasswordAccessibilityLabel,
  ...textFieldProps
}: PasswordFieldProps) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <TextField
      {...textFieldProps}
      secureTextEntry={!isVisible}
      autoCapitalize="none"
      autoComplete="password"
      textContentType="password"
      prefix={Lock}
      suffix={isVisible ? EyeOff : Eye}
      onSuffixPress={() => setIsVisible((current) => !current)}
      suffixAccessibilityLabel={
        isVisible ? hidePasswordAccessibilityLabel : showPasswordAccessibilityLabel
      }
    />
  )
}
